/* ==========================================================================
   AA PDP — refonte fiche produit (chargé uniquement par le template test_benjo)
   - cartes pour les options courtes (≤ 4 valeurs) ou de type pack / version / coffret
   - vignettes d'images sur les options illustrées (modèle, finition…)
   - options longues repliées avec bouton « Voir les N autres »
   - valeur sélectionnée affichée dans le libellé d'option
   - sommaire (liens) généré depuis les titres de la description
   - photos supplémentaires sous la galerie (desktop)
   - barre d'achat collante sur mobile / tablette
   N'altère aucun fichier du thème : s'appuie sur ses événements et son formulaire.
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('aa-pdp-config');
  if (!cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var COLLAPSE_AFTER = cfg.collapseAfter || 8;
  /* BBL début modif — 25/10/2026 : textes du script dans la langue du visiteur (6 langues, anglais par défaut hors français) */
  var AA_LANG = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var AA_TX = {
    fr: { more: '+ Voir les {n} autres ({o})', less: 'Réduire', toc: 'Sommaire de la fiche', view: 'vue' },
    en: { more: '+ See {n} more ({o})', less: 'Show less', toc: 'Page contents', view: 'view' },
    de: { more: '+ {n} weitere anzeigen ({o})', less: 'Weniger anzeigen', toc: 'Inhalt', view: 'Ansicht' },
    nl: { more: '+ Bekijk {n} meer ({o})', less: 'Minder tonen', toc: 'Inhoud', view: 'weergave' },
    it: { more: '+ Vedi altri {n} ({o})', less: 'Mostra meno', toc: 'Indice', view: 'vista' },
    es: { more: '+ Ver {n} más ({o})', less: 'Mostrar menos', toc: 'Índice', view: 'vista' }
  };
  var AA_T = AA_TX[AA_LANG] || AA_TX.en;
  /* BBL fin modif */

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getForm() {
    return document.querySelector('.section--product-single form.js-product-form[id^="product-form-"]');
  }

  var cardSets = [];
  function variantsData() {
    var el = document.querySelector('.section--product-single variant-radios script[type="application/json"]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    /* BBL début modif — 25/10/2026 : prix formaté selon la langue du visiteur (et non plus toujours fr-FR) ; secours avec le code de la devise active */
    var loc = document.documentElement.lang || 'fr';
    try { return (cents / 100).toLocaleString(loc, { style: 'currency', currency: cur }); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
    /* BBL fin modif */
  }
  /* BBL début modif — 19/10/2026 : URL de vignette 120 px pour les cartes */
  function cardImg(src, size) {
    var px = size || 120;
    var u = String(src).replace(/^\/\//, 'https://');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px + '&height=' + px + '&crop=center';
  }
  /* BBL début modif — 19/10/2026 : changement de photo fluide
     - les mini-photos de toutes les variantes sont préchargées quand la page a fini de charger
       (navigateur au repos, priorité basse) : aucun impact sur la vitesse d'affichage
     - au changement d'option, la nouvelle photo s'affiche en fondu, une fois chargée (jamais de case vide) */
  var aaReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var aaImgCache = {};
  function fileName(u) { return String(u || '').split('?')[0].split('/').pop(); }
  function preloadImg(url, cb) {
    var c = aaImgCache[url];
    if (c && c.ok) { if (cb) cb(); return; }
    if (!c) {
      c = aaImgCache[url] = { ok: false, cbs: [] };
      var img = new Image();
      img.decoding = 'async';
      try { img.fetchPriority = 'low'; } catch (e) {}
      img.onload = img.onerror = function () {
        c.ok = true;
        var list = c.cbs; c.cbs = [];
        list.forEach(function (f) { f(); });
      };
      img.src = url;
    }
    if (cb) c.cbs.push(cb);
  }
  function setPhoto(el, url) {
    if (el.dataset.aaSrc === url) return;
    var first = !el.dataset.aaSrc;
    el.dataset.aaSrc = url;
    var cur = (el.style.backgroundImage.match(/url\("?([^")]+)"?\)/) || [])[1];
    if (first && fileName(cur) === fileName(url)) return; /* déjà la bonne photo au chargement */
    preloadImg(url, function () {
      if (el.dataset.aaSrc !== url) return;
      if (aaReduce || first) { el.style.backgroundImage = 'url("' + url + '")'; return; }
      el.style.transition = 'opacity .12s ease';
      el.style.opacity = '0.15';
      setTimeout(function () {
        if (el.dataset.aaSrc !== url) return;
        el.style.backgroundImage = 'url("' + url + '")';
        el.style.transition = 'opacity .22s ease';
        el.style.opacity = '1';
      }, 120);
    });
  }
  function preloadVariantPhotos() {
    var picker = document.querySelector('.section--product-single variant-radios');
    if (!picker) return;
    var hasCards = !!picker.querySelector('.aa-card__img');
    var hasThumbs = !!picker.querySelector('.aa-thumb');
    if (!hasCards && !hasThumbs) return;
    var seen = {};
    variantsData().slice(0, 120).forEach(function (v) {
      var src = v.featured_image && v.featured_image.src;
      if (!src || seen[src]) return;
      seen[src] = 1;
      if (hasCards) preloadImg(cardImg(src));
      if (hasThumbs) preloadImg(cardImg(src, 160));
    });
  }
  /* BBL début modif — 27/10/2026 : grandes photos des variantes chargées à l'avance (galerie en chargement différé)
     quand la page est au repos, pour qu'un changement d'option (couleur…) affiche la photo sans attente */
  function preloadGalleryVariants() {
    var names = {};
    variantsData().slice(0, 120).forEach(function (v) {
      var src = v.featured_image && v.featured_image.src;
      if (src) names[fileName(src)] = 1;
    });
    var n = 0;
    document.querySelectorAll('.section--product-single .product-single__media img[loading="lazy"]').forEach(function (img) {
      if (n >= 24) return;
      var f = fileName(img.getAttribute('src') || img.currentSrc || '');
      if (!names[f]) return;
      img.loading = 'eager';
      n++;
    });
  }
  /* BBL fin modif */

  function whenIdle(fn) {
    var go = function () {
      if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 3000 });
      else setTimeout(fn, 1200);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go);
  }
  /* BBL fin modif */
  /* Valeurs inexistantes : une valeur d'option qui n'existe dans aucune variante avec les options
     choisies au-dessus est masquée (ex. DÉDALE : seuls les modèles du niveau choisi s'affichent) */
  function updateExisting() {
    var picker = document.querySelector('.section--product-single variant-radios');
    if (!picker) return;
    var variants = variantsData();
    if (!variants.length) return;
    var fieldsets = picker.querySelectorAll('fieldset.product-form__swatch');
    var selected = Array.prototype.map.call(fieldsets, function (f) {
      var c = f.querySelector('input:checked'); return c ? c.value : null;
    });
    Array.prototype.forEach.call(fieldsets, function (fs, idx) {
      if (idx === 0) return;
      fs.querySelectorAll('.product-form__swatch__item').forEach(function (it) {
        var input = it.querySelector('input');
        if (!input) return;
        var exists = variants.some(function (x) {
          if (x.options[idx] !== input.value) return false;
          for (var j = 0; j < idx; j++) { if (selected[j] != null && x.options[j] !== selected[j]) return false; }
          return true;
        });
        it.style.display = (exists || input.checked) ? '' : 'none';
      });
      if (fs.aaRender) fs.aaRender();
    });
  }
  /* Vignettes photo des options longues (plus de 8 valeurs) : même principe que les cartes */
  function updateOptionThumbs() {
    var picker = document.querySelector('.section--product-single variant-radios');
    if (!picker || !picker.querySelector('.aa-thumb')) return;
    var variants = variantsData();
    var fieldsets = picker.querySelectorAll('fieldset.product-form__swatch');
    var selected = Array.prototype.map.call(fieldsets, function (f) {
      var c = f.querySelector('input:checked'); return c ? c.value : null;
    });
    Array.prototype.forEach.call(fieldsets, function (fs, idx) {
      fs.querySelectorAll('.product-form__swatch__item').forEach(function (it) {
        var input = it.querySelector('input');
        var t = it.querySelector('.aa-thumb');
        if (!input || !t) return;
        var wanted = selected.slice(); wanted[idx] = input.value;
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return wanted[i] == null || o === wanted[i]; });
        })[0];
        if (v && v.featured_image && v.featured_image.src) {
          setPhoto(t, cardImg(v.featured_image.src, 160));
        }
      });
    });
  }
  /* BBL fin modif */
  function updateCardPrices() {
    if (!cardSets.length) return;
    var variants = variantsData();
    var picker = document.querySelector('.section--product-single variant-radios');
    if (!picker) return;
    var fieldsets = picker.querySelectorAll('fieldset.product-form__swatch');
    var selected = Array.prototype.map.call(fieldsets, function (f) {
      var c = f.querySelector('input:checked'); return c ? c.value : null;
    });
    cardSets.forEach(function (set) {
      set.fs.querySelectorAll('.aa-card__price').forEach(function (el) {
        var wanted = selected.slice(); wanted[set.position] = el.dataset.value;
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return wanted[i] == null || o === wanted[i]; });
        })[0];
        el.textContent = v ? money(v.price) : '';
        /* BBL début modif — 19/10/2026 : la mini-photo de la carte suit les autres options choisies */
        var lab = el.closest('label');
        var im = lab && lab.querySelector('.aa-card__img');
        /* BBL modif 27/10/2026 : une pastille de couleur reste une pastille (pas remplacée par la photo) */
        if (im && !im.dataset.aaSwatch && v && v.featured_image && v.featured_image.src) {
          setPhoto(im, cardImg(v.featured_image.src));
        }
        /* BBL fin modif */
      });
    });
  }
  function enhanceOptions() {
    var pickers = document.querySelectorAll('.section--product-single variant-radios');
    pickers.forEach(function (picker) {
      var fieldsets = picker.querySelectorAll('fieldset.product-form__swatch');
      fieldsets.forEach(function (fs, idx) {
        if (fs.dataset.aaDone) return;
        fs.dataset.aaDone = '1';
        var position = String(idx + 1);
        var items = Array.prototype.slice.call(fs.querySelectorAll('.product-form__swatch__item'));
        var legend = fs.querySelector('legend');

        if (legend && !legend.querySelector('.aa-opt-val, .js-option-title')) {
          var val = document.createElement('span');
          val.className = 'aa-opt-val';
          legend.appendChild(val);
        }
        function syncLabel() {
          var checked = fs.querySelector('input:checked');
          var span = legend && legend.querySelector('.aa-opt-val');
          if (span) span.textContent = checked ? ': ' + checked.value : '';
        }
        syncLabel();
        fs.addEventListener('change', syncLabel);
        fs.addEventListener('click', function () { setTimeout(syncLabel, 0); });

        var cards = cfg.optionCards && cfg.optionCards[position];
        if (cards) {
          fs.classList.add('aa-opt-cards');
          items.forEach(function (it) {
            var input = it.querySelector('input');
            var label = it.querySelector('label');
            if (!input || !label || label.querySelector('.aa-card__top')) return;
            var info = cards[input.value] || {};
            label.textContent = '';
            var top = document.createElement('span'); top.className = 'aa-card__top';
            var nm = document.createElement('span'); nm.className = 'aa-card__name'; nm.textContent = input.value;
            var pr = document.createElement('span'); pr.className = 'aa-card__price'; pr.dataset.value = input.value;
            if (info.i) {
              var im = document.createElement('span'); im.className = 'aa-card__img'; im.setAttribute('aria-hidden', 'true');
              im.style.backgroundImage = 'url("' + info.i + '")';
              label.appendChild(im); label.classList.add('aa-card--img');
              /* BBL début modif — 27/10/2026 : pastille de couleur (pas de photo propre à chaque coloris) : petite pastille ronde à gauche du nom */
              if (String(info.i).indexOf('data:image/svg') === 0) { im.dataset.aaSwatch = '1'; label.classList.add('aa-card--dot'); }
              /* BBL fin modif */
            }
            top.appendChild(nm); top.appendChild(pr); label.appendChild(top);
            if (info.d) { var d = document.createElement('span'); d.className = 'aa-card__desc'; d.textContent = info.d; label.appendChild(d); }
            if (info.b) { var b = document.createElement('span'); b.className = 'aa-card__badge'; b.textContent = info.b; label.appendChild(b); }
          });
          cardSets.push({ fs: fs, position: idx });
        }

        var imgs = !cards && cfg.optionImages && cfg.optionImages[position];
        if (imgs) {
          fs.classList.add('aa-opt-images');
          items.forEach(function (it) {
            var input = it.querySelector('input');
            var label = it.querySelector('label');
            var url = input && imgs[input.value];
            if (url && label && !label.querySelector('.aa-thumb')) {
              var t = document.createElement('span');
              t.className = 'aa-thumb';
              t.setAttribute('aria-hidden', 'true');
              t.style.backgroundImage = 'url("' + url + '")';
              label.insertBefore(t, label.firstChild);
            }
          });
        }

        /* BBL début modif — 19/10/2026 : repli recalculé sur les valeurs réellement proposées
           (les valeurs qui n'existent pas avec les options déjà choisies sont masquées, voir updateExisting) */
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'aa-opt-toggle';
        var optName = legend ? legend.firstChild.textContent.trim().toLowerCase() : 'options';
        var expanded = false;
        function render() {
          var visible = items.filter(function (it) { return it.style.display !== 'none'; });
          var isLong = visible.length > COLLAPSE_AFTER + 4;
          var extra = isLong ? visible.slice(COLLAPSE_AFTER) : [];
          items.forEach(function (it) { it.classList.remove('aa-opt-more'); });
          if (!isLong) {
            btn.style.display = 'none';
            fs.classList.remove('aa-opt-collapsed');
            return;
          }
          btn.style.display = '';
          fs.classList.toggle('aa-opt-collapsed', !expanded);
          extra.forEach(function (it) {
            var inp = it.querySelector('input');
            if (!(inp && inp.checked)) it.classList.add('aa-opt-more');
          });
          /* BBL début modif — 25/10/2026 : libellés du bouton traduits (AA_T) */
          btn.textContent = expanded ? AA_T.less : AA_T.more.replace('{n}', extra.length).replace('{o}', optName);
          /* BBL fin modif */
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
        btn.addEventListener('click', function () { expanded = !expanded; render(); });
        fs.addEventListener('change', function () { setTimeout(render, 0); });
        fs.appendChild(btn);
        fs.aaRender = render;
        render();
        /* BBL fin modif */
      });
      if (!picker.dataset.aaCards) {
        picker.dataset.aaCards = '1';
        /* BBL début modif — 19/10/2026 : photos des vignettes mises à jour aussi */
        picker.addEventListener('change', function () { setTimeout(updateExisting, 0); setTimeout(updateCardPrices, 0); setTimeout(updateOptionThumbs, 0); });
        /* BBL fin modif */
      }
    });
    updateExisting(); /* BBL modif 19/10/2026 */
    updateCardPrices();
    updateOptionThumbs(); /* BBL modif 19/10/2026 */
  }

  function slug(s) {
    return 'aa-' + s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
  }
  function shortLabel(text) {
    var t = text.replace(/\s+/g, ' ').trim();
    if (t.length <= 28) return t;
    var cut = t.slice(0, 28);
    var sp = cut.lastIndexOf(' ');
    return (sp > 12 ? cut.slice(0, sp) : cut).replace(/[\s,;:—–-]+$/, '') + '…';
  }
  function buildToc() {
    var rte = document.querySelector('.aa-pc .rte');
    var slot = document.querySelector('.aa-pc__toc');
    if (!rte || !slot || document.querySelector('.aa-toc')) return;
    var heads = Array.prototype.slice.call(rte.querySelectorAll('h2, h3.aa-title, h3'))
      .filter(function (h) { return h.textContent.trim().length > 2 && !h.closest('details, summary'); });
    var useAa = heads.some(function (h) { return h.classList.contains('aa-title'); });
    if (useAa) heads = heads.filter(function (h) { return h.tagName === 'H2' || h.classList.contains('aa-title'); });
    heads = heads.slice(0, 8);
    var links = [];
    heads.forEach(function (h) {
      var label = shortLabel(h.textContent);
      if (!h.id) h.id = slug(h.textContent);
      h.classList.add('aa-anchor');
      links.push({ id: h.id, label: label, el: h });
    });
    if (links.length < 2) return;
    var nav = document.createElement('nav');
    nav.className = 'aa-toc';
    nav.setAttribute('aria-label', AA_T.toc); /* BBL modif 25/10/2026 : libellé traduit */
    var inner = document.createElement('div');
    inner.className = 'aa-toc__inner';
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.href = '#' + l.id;
      a.textContent = l.label;
      a.dataset.target = l.id;
      inner.appendChild(a);
    });
    nav.appendChild(inner);
    slot.appendChild(nav);
  }

  function guardColumnHeight() {
    var box = document.querySelector('.section--product-single .product-single__primary-blocks .product-single__box');
    var primary = box && box.closest('.product-single__primary-blocks');
    var wrap = primary && primary.parentElement;
    if (!box || !wrap) return;
    function apply() {
      if (window.matchMedia('(min-width: 980px)').matches) {
        wrap.style.minHeight = Math.ceil(box.getBoundingClientRect().height + 24) + 'px';
      } else {
        wrap.style.minHeight = '';
      }
    }
    apply();
    if ('ResizeObserver' in window) new ResizeObserver(apply).observe(box);
    window.addEventListener('resize', apply);
  }

  function fillGallery() {
    var urls = cfg.gallery || [];
    var media = document.querySelector('.section--product-single .product-single__media');
    var box = document.querySelector('.section--product-single .product-single__primary-blocks .product-single__box');
    if (!media || !box || !urls.length) return;
    if (!window.matchMedia('(min-width: 980px)').matches) return;
    if (media.querySelector('.aa-gallery-more')) return;
    var free = box.getBoundingClientRect().bottom - media.getBoundingClientRect().bottom - 16;
    var width = media.getBoundingClientRect().width;
    var pick = null;
    [2, 3, 4].some(function (cols) {
      var rowH = (width - 12 * (cols - 1)) / cols + 12;
      var rows = Math.floor((free + 12) / rowH);
      if (rows >= 1 && urls.length >= cols) { pick = { cols: cols, n: Math.min(rows * cols, urls.length - (urls.length % cols)) }; return true; }
      return false;
    });
    if (!pick || pick.n < pick.cols) return;
    var n = pick.n;
    var grid = document.createElement('div');
    grid.className = 'aa-gallery-more';
    grid.style.gridTemplateColumns = 'repeat(' + pick.cols + ', minmax(0, 1fr))';
    var title = (document.querySelector('.product-single__title') || {}).textContent || '';
    urls.slice(0, n).forEach(function (u, i) {
      var img = document.createElement('img');
      img.src = u; img.loading = 'lazy'; img.decoding = 'async';
      img.alt = title.trim() + ' — ' + AA_T.view + ' ' + (i + 2); /* BBL modif 25/10/2026 : texte alternatif traduit */
      grid.appendChild(img);
    });
    media.appendChild(grid);
  }

  function buildSticky() {
    var form = getForm();
    var bar = document.getElementById('aa-sticky');
    if (!form || !bar) return;
    document.body.appendChild(bar);
    document.body.classList.add('aa-sticky-on');
    var sectionId = (form.getAttribute('id') || '').replace('product-form-', '');
    var addBtn = form.querySelector('[name="add"]');
    var priceEl = document.getElementById('price-' + sectionId);
    var priceOut = bar.querySelector('.aa-sticky__price');
    var variantOut = bar.querySelector('.aa-sticky__variant');
    var stickyBtn = bar.querySelector('.aa-sticky__btn');

    var variants = [];
    var dataEl = document.querySelector('.section--product-single variant-radios script[type="application/json"], .section--product-single variant-selects script[type="application/json"], .section--product-single variant-mixed-inputs script[type="application/json"]');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }

    function syncPrice() {
      if (!priceEl) return;
      var cur = priceEl.querySelector('.price__number .money, .price__number') || priceEl;
      priceOut.textContent = cur.textContent.replace(/\s+/g, ' ').trim();
    }
    function syncVariant() {
      var idInput = form.querySelector('input[name="id"]');
      var id = idInput && Number(idInput.value);
      var v = variants.filter(function (x) { return x.id === id; })[0];
      variantOut.textContent = v && v.title !== 'Default Title' ? v.title.replace(/ \/ /g, ' · ') : '';
    }
    function syncBtn() {
      if (!addBtn) return;
      stickyBtn.disabled = addBtn.disabled;
      var txt = addBtn.querySelector('staged-action-text');
      stickyBtn.textContent = addBtn.disabled && txt ? txt.textContent.trim() : (cfg.addLabel || 'Ajouter au panier');
    }
    function syncAll() { syncPrice(); syncVariant(); syncBtn(); }
    syncAll();

    form.addEventListener('change', function () { setTimeout(syncAll, 30); });
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    if (addBtn && 'MutationObserver' in window) {
      new MutationObserver(syncBtn).observe(addBtn, { attributes: true, childList: true, subtree: true });
    }

    stickyBtn.addEventListener('click', function () {
      if (addBtn && !addBtn.disabled) addBtn.click();
    });

    var target = form.closest('.product-single__box__block') || form;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', below);
        bar.setAttribute('aria-hidden', below ? 'false' : 'true');
      }).observe(target);
    }
  }

  ready(function () {
    function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[aa-pdp]', e); } }
    safe(enhanceOptions);
    whenIdle(function () { safe(preloadVariantPhotos); }); /* BBL modif 19/10/2026 */
    whenIdle(function () { safe(preloadGalleryVariants); }); /* BBL modif 27/10/2026 */
    /* BBL début modif — 19/10/2026 : le sélecteur reste invisible tant qu'il n'est pas mis en forme (voir aa-pdp-all.css) */
    /* affiché deux images plus tard : les couleurs finales sont posées sans animation, pas de flash bleu */
    var aaShow = function () { document.querySelectorAll('.section--product-single variant-radios').forEach(function (p) { p.classList.add('aa-ready'); }); };
    if (window.requestAnimationFrame) requestAnimationFrame(function () { requestAnimationFrame(aaShow); }); else setTimeout(aaShow, 30);
    /* BBL fin modif */
    safe(buildToc);
    safe(buildSticky);
    safe(guardColumnHeight);
    // Photos supplémentaires sous la galerie désactivées : elles se superposaient
    // à la galerie collante du thème au défilement (05/10/2026).
  });
})();